import { defineMessages } from "react-intl";

/**
 * SFCC-11723 — i18n message catalog for the GoalQuestionnaire block
 * (`learning-center-questionnaire/*`).
 */
const messages = defineMessages({
  estimatedTime: {
    id: "learningCenter.questionnaire.estimated_time",
    defaultMessage: "Less than 1 min",
  },
  back: {
    id: "learningCenter.questionnaire.back",
    defaultMessage: "Back",
  },
  benefitsHeading: {
    id: "learningCenter.questionnaire.benefits_heading",
    defaultMessage: "Benefits",
  },
  goalLabel: {
    id: "learningCenter.questionnaire.goal_label",
    defaultMessage: "Goal: {title}",
  },
  signInToLearnMore: {
    id: "learningCenter.questionnaire.sign_in_to_learn_more",
    defaultMessage: "Sign in to Learn More",
  },
  startLearning: {
    id: "learningCenter.questionnaire.start_learning",
    defaultMessage: "Start Learning",
  },
  starting: {
    id: "learningCenter.questionnaire.starting",
    defaultMessage: "Starting…",
  },
  goalsAndBenefitsHeading: {
    id: "learningCenter.questionnaire.goals_and_benefits_heading",
    defaultMessage: "HSA Goals and Benefits",
  },
});

export default messages;
